import React, { Component } from 'react';

//componentes
import RegistroPagos from './registroCompras'

class Index extends Component {

    render(){
        return(
            <div>
                <RegistroPagos />
            </div>
        );
    }

}
export default Index;